import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { tA11y } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';

type ModalCloseProps = {
  onClick?: (e: any) => void;
  color?: string;
  margin?: string;
};
const ModalCloseButton = ({ onClick, color, margin }: ModalCloseProps) => {
  const classes = useStyles({
    color: color || 'black',
    margin: margin || '-10',
  });
  return (
    <IconButton
      aria-label={tA11y('alt.close')}
      className={classes.closeButton}
      onClick={onClick}
      size="large"
    >
      <FontAwesomeIcon icon={faTimes} className={classes.closeIcon} />
    </IconButton>
  );
};

const useStyles = makeStyles(() => ({
  closeButton: {
    width: '60px',
    height: '100%',
    margin: (props: any) => props.margin,
    padding: 10,
    top: 0.5,
    color: (props: any) => props.color,
    textAlign: 'center',
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: 'unset !important',
    },
  },
  closeIcon: {
    fontSize: 24,
  },
}));

export default ModalCloseButton;
